// src/api/evaluate.js
import request from '@/utils/request'

// api接口列表
const api = {
	type: 'evaluation/type',
	list: 'evaluation/list',
	detail: 'evaluation/detail',
	singleStart: 'evaluation/start_answer',
	singleQues: 'evaluation/question/list',
	singleSub: 'evaluation/submit_answer',
	portraitList: 'evaluation/careers',
	portraitSub: 'evaluation/careers/submit',
	personalList: 'evaluation/intention',
	personalSub: 'evaluation/intention/submit',
	record: 'evaluation/record',
	report: 'evaluation/report/check_view',
	sunmit: 'evaluation/final_submit',
	major: 'evaluation/major',
	exportReport: 'evaluation/report'
}

// 分类
export function type(params) {
	return request({
		url: api.type,
		method: 'get',
		params
	})
}

// 列表
export function list(params) {
	return request({
		url: api.list,
		method: 'get',
		params
	})
}


// 详情
export function detail(params) {
	return request({
		url: api.detail,
		method: 'get',
		params
	})
}

//  学业测评，单题 详情
export function singleStart(data) {
	return request({
		url: api.singleStart,
		method: 'post',
		data
	})
}

// 学业测评，单题 题目
export function singleQues(params) {
	return request({
		url: api.singleQues,
		method: 'get',
		params
	})
}

// 学业测评，单题
export function singleSub(data) {
	return request({
		url: api.singleSub,
		method: 'post',
		data
	})
}

// 职业肖像题目
export function portraitList(params) {
	return request({
		url: api.portraitList,
		method: 'get',
		params
	})
}

// 职业肖像 提交
export function portraitSub(data) {
	return request({
		url: api.portraitSub,
		method: 'post',
		data
	})
}


// 个人意向 题目
export function personalList(params) {
	return request({
		url: api.personalList,
		method: 'get',
		params
	})
}

// 个人意向 提交
export function personalSub(data) {
	return request({
		url: api.personalSub,
		method: 'post',
		data
	})
}

export function record(params) {
	return request({
		url: api.record,
		method: 'get',
		params
	})
}


export function report(params) {
	return request({
		url: api.report,
		method: 'get',
		params
	})
}

// 提交
export function sunmit(data) {
	return request({
		url: api.sunmit,
		method: 'post',
		data
	})
}

export function major(params) {
	return request({
		url: api.major,
		method: 'get',
		params
	})
}

export function exportReport(params) {
	return request({
		url: api.exportReport,
		method: 'get',
		params
	})
}